import { Button } from '../../../components/ui/Button'
import type { AiTool } from '../../../api/types'

const OPTIONS: { value: AiTool; label: string }[] = [
  { value: 'CLAUDE', label: 'Claude' },
  { value: 'CODEX', label: 'Codex' },
]

interface AiToolToggleProps {
  value: AiTool | null
  onChange: (value: AiTool | null) => void
}

// Einzelauswahl: erneutes Klicken der bereits aktiven Option hebt die Auswahl wieder auf
// (aiTool bleibt optional — nicht jede Aufgabe hat einen KI-Arbeitsauftrag für ein
// bestimmtes Tool).
export function AiToolToggle({ value, onChange }: AiToolToggleProps) {
  return (
    <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
      {OPTIONS.map((opt) => (
        <Button
          key={opt.value}
          type="button"
          size="sm"
          variant={value === opt.value ? 'primary' : 'secondary'}
          onClick={() => onChange(value === opt.value ? null : opt.value)}
        >
          {opt.label}
        </Button>
      ))}
    </div>
  )
}
